
import React from "react";
import BackgroundCards from "./BackgroundCards";
import EducationTimeline from "./EducationTimeline";

const BackgroundSection = () => {
  return (
    <div className="mb-16">
      <h2 className="text-2xl font-medium mb-4 text-center">Minu taust</h2>
      <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mx-auto mb-10"></div>
      
      <BackgroundCards />
      <EducationTimeline />
    </div>
  );
};

export default BackgroundSection;
